module.exports = __webpack_public_path__ + "static/media/search-background.7bddc70f.jpg";